/**
 * 认证状态 200 成功绑定 203 未绑定 204 绑定失败/重新授权
 * @type {{UNBIND: number, SUCCESS: number, FAIL: number}}
 */
export const AUTH_FLAG = {
  // 成功绑定
  SUCCESS: 200,
  // 未绑定
  UNBIND: 203,
  // 绑定失败/重新授权
  FAIL: 204,
  //其他情况
  OTHER_ERROR: 400
}
